export const CHAMPION_LOCATIONS: string[] = [
  "'S-Hertogenbosch, Netherlands",
  '1480, Norway',
  '502 Wellis Minami Nagareyama, 9-4-1 Minaminagareyama,Nagareyama-Shi, Japan',
  'Abu Dhabi, United Arab Emirates',
  'Abu Halifa, Kuwait',
  'Acworth, United States of America',
  'Adachi-Ku, Japan',
  'Adelaide, Australia',
  'Ajax, Canada',
  'Akashi-Cho, Chuo-Ku, Japan',
  'Albany, United States of America',
  'Albertville, United States of America',
  'Alby-Sur-Chéran, France',
  'Alexandria, United States of America',
  'Alingsås, Sweden',
  'Almelo, Netherlands',
  'Alton, United Kingdom',
  'Amarillo, United States of America',
  'Amersfoort, Netherlands',
  'Amman, Jordan',
  'Amsterdam, Netherlands',
  'Anan, Japan',
  'Angers, France',
  'Ankara, Turkey',
  'Ann Arbor, United States of America',
  'Antwerp, Belgium',
  'Antwerpen, Belgium',
  'Apeldoorn, Netherlands',
  'Apex, United States of America',
  'Apopka, United States of America',
  'Apple Valley, United States of America',
  'Arezzo, Italy',
  'Ashford, United Kingdom',
  'Ashington, United Kingdom',
  'Ashover, United Kingdom',
  'Astoria, United States of America',
  'Astwood Bank, United Kingdom',
  'Asunción, Paraguay',
  'Aswan, Egypt',
  'Athens, Greece',
  'Atibaia, Brazil',
  'Atlanta, United States of America',
  'Auburn, United States of America',
  'Auckland, New Zealand',
  'Auckland, Wellington. Australia = Sydney, Brisbane And Melbourne, New Zealand',
  'Aurora, United States of America',
  'Austin, United States of America',
  'Aylesbury, United Kingdom',
  'Ballarat, Australia',
  'Baltimore, United States of America',
  'Banbridge, United Kingdom',
  'Bandeirantes, Brazil',
  'Bandung, Indonesia',
  'Bangalore, India',
  'Barcelona, Spain',
  'Barnstaple, United Kingdom',
  'Barrington, United States of America',
  'Bartlett, United States of America',
  'Basel, Switzerland',
  'Batavia, United States of America',
  'Bath, United Kingdom',
  'Bedford, United Kingdom',
  'Beers, Netherlands',
  'Belas, Portugal',
  'Belfast, United Kingdom',
  'Belo Horizonte, Brazil',
  'Bengaluru, India',
  'Bergen, Norway',
  'Berlin, Germany',
  'Bern, Switzerland',
  'Bertem, Belgium',
  'Beulah, United States of America',
  'Bielefeld, Germany',
  'Billingstad, Norway',
  'Binghamton, United States of America',
  'Birmingham, United Kingdom',
  'Birmingham, United States of America',
  'Blacktown, Australia',
  'Blakeney, United Kingdom',
  'Bloomington, United States of America',
  'Blumenau, Brazil',
  'Bochum, Germany',
  'Bogota, Colombia',
  'Bonner Springs, United States of America',
  'Bording, Denmark',
  'Boston, United States of America',
  'Braga, Portugal',
  'Brampton, Canada',
  'Brasília, Brazil',
  'Bratislava, Slovakia',
  'Braunschweig, Germany',
  'Breda, Netherlands',
  'Bregenz, Austria',
  'Brentwood, United States of America',
  'Brescia, Italy',
  'Bridlington, United Kingdom',
  'Brisbane, Australia',
  'Bristol, United Kingdom',
  'Broerup, Denmark',
  'Brussels, Belgium',
  'Bucharest, Romania',
  'Buckeye, United States of America',
  'Budapest, Hungary',
  'Budd Lake, United States of America',
  'Buenos Aires, Argentina',
  'Buffalo Grove, United States of America',
  'Buffalo, United States of America',
  'Buford, United States of America',
  'Burlington, Canada',
  'Byron Center, United States of America',
  'Böblingen, Germany',
  'Bückeburg, Germany',
  'Cainta, Philippines',
  'Cairo, Egypt',
  'Caledon, Canada',
  'Caledonia, Canada',
  'Calgary, Canada',
  'Caloundra West, Australia',
  'Camaragibe, Brazil',
  'Camberwell, Australia',
  'Cambourne, United Kingdom',
  'Cambridge, Canada',
  'Camp Hill, United States of America',
  'Campinas, Brazil',
  'Cantonment, United States of America',
  'Cape Town, South Africa',
  'Capellen, Luxembourg',
  'Caracas, Venezuela',
  'Cardiff, United Kingdom',
  'Carlisle, United Kingdom',
  'Carlsbad, United States of America',
  'Carolina, United States of America',
  'Carson, United States of America',
  'Cary, United States of America',
  'Casablanca, Morocco',
  'Casalecchio Di Reno (Bo), Italy',
  'Cascais, Portugal',
  'Castelldefels, Spain',
  'Castle Pines, United States of America',
  'Castlewood, United States of America',
  'Cave Creek, United States of America',
  'Cdmx, Mexico',
  'Cedar Park, United States of America',
  'Centreville, United States of America',
  'Chambery, France',
  'Changwon-Si, South Korea',
  'Charlott, United States of America',
  'Charlotte, United States of America',
  'Chatenay-Malabry, France',
  'Chattanooga, United States of America',
  'Cheltenham, United Kingdom',
  'Chennai, India',
  'Chester, United Kingdom',
  'Chesterfield, United Kingdom',
  'Chesterfield, United States of America',
  'Chiavenna, Italy',
  'Chicago, United States of America',
  'Chico, United States of America',
  'Chiyoda, Japan',
  'Chofu-Shi, Japan',
  'Chuo, Japan',
  'Chuo-Ku, Japan',
  'Cincinnati, United States of America',
  'Ciudad Autonoma De Buenos Aires, Argentina',
  'Ciudad De México, Mexico',
  'Ciudad De Panamá, Panama',
  'Clairefontaine-En-Yvelines, France',
  'Clemmons, United States of America',
  'Clive, United States of America',
  'Coburg, Germany',
  'Cologne, Germany',
  'Colombes, France',
  'Colombo, Sri Lanka',
  'Colorado Springs, United States of America',
  'Columbia, United States of America',
  'Columbus, United States of America',
  'Commack, United States of America',
  'Conway, United States of America',
  'Copenhagen, Denmark',
  'Corcoran, United States of America',
  'Corona, United States of America',
  'Cortland, United States of America',
  'Cottage Grove, United States of America',
  'Courbevoie, France',
  'Coventry, United Kingdom',
  'Crawley, United Kingdom',
  'Crofton, United States of America',
  'Cromer, Australia',
  'Crownsville, United States of America',
  'Cumming, United States of America',
  'Curitiba, Brazil',
  'Cwmbran, United Kingdom',
  'Dallas, United States of America',
  'Danbury, United States of America',
  'Darmstadt, Germany',
  'Davey, United States of America',
  'Dayton, United States of America',
  'Delaware, United States of America',
  'Den Bosch, Netherlands',
  'Denton, United States of America',
  'Denver, United States of America',
  'Deposit, United States of America',
  'Derby, United Kingdom',
  'Dewitt, United States of America',
  'Dhahran, Saudi Arabia',
  'Diemen, Netherlands',
  'Diez, Germany',
  'Dijon, France',
  'Doha, Qatar',
  'Dollard-Des-Ormeaux, Canada',
  'Doncaster East, Australia',
  'Dubai, United Arab Emirates',
  'Dublin, Ireland',
  'Dublin, United States of America',
  'Duesseldorf, Germany',
  'Duluth, United States of America',
  'Durbanville, South Africa',
  'Durham, United States of America',
  'Düsseldorf, Germany',
  'Eagle Mountain, United States of America',
  'Ealing, United Kingdom',
  'East Brunswick, United States of America',
  'Ede, Netherlands',
  'Edgewater, United States of America',
  'Edinburgh, United Kingdom',
  'Ehningen, Germany',
  'Eighty-Four, United States of America',
  'Eindhoven, Netherlands',
  'El Segundo, United States of America',
  'Elizabeth, United States of America',
  'Elk River, United States of America',
  'Elkton, United States of America',
  'Emporia, United States of America',
  'Emsworth, United Kingdom',
  'Epinay Sur Seine, France',
  'Espoo, Finland',
  'Essen, Germany',
  'Essex, United Kingdom',
  'Esslingen Am Neckar, Germany',
  'Exton, United States of America',
  'Fall Church, United States of America',
  'Fazenda Rio Grande, Brazil',
  'Fellbach, Germany',
  'Fennville, United States of America',
  'Fenton, United States of America',
  'Flemington, United States of America',
  'Florham Park, United States of America',
  'Fombell, United States of America',
  'Fort Collins, United States of America',
  'Fort Wayne, United States of America',
  'Fort Worth, United States of America',
  'Fountainhall, United Kingdom',
  'Framingham, United States of America',
  'Frankfurt Am Main, Germany',
  'Frankfurt, Germany',
  'Franklin, United States of America',
  'Fredericton, Canada',
  'Frederiksberg, Denmark',
  'Freising, Germany',
  'Frisco, United States of America',
  'Fruitport, United States of America',
  'Fuchu, Japan',
  'Fuerth, Germany',
  'Fukuoka-Shi, Japan',
  'Fusagasuga, Colombia',
  'Fürth, Germany',
  'Gainesville, United States of America',
  'Garlica Murowana, Poland',
  'Gavle, Sweden',
  'Gdansk, Poland',
  'Gdynia, Poland',
  'Geneva, Switzerland',
  'Gent, Belgium',
  'Georgetown, United States of America',
  'Ghent, Belgium',
  'Gijon, Spain',
  'Gilten, Germany',
  'Glen Allen, United States of America',
  'Glenview, United States of America',
  'Glenwood Landing, United States of America',
  'Glenwood, United States of America',
  'Gliwice, Poland',
  'Glonn, Germany',
  'Gothenburg, Sweden',
  'Grafenberg, Germany',
  'Graz, Austria',
  'Green Lane, United States of America',
  'Greven, Germany',
  'Guatemala, Guatemala',
  'Guntur, India',
  'Guyancourt, France',
  'Haar Near Munich, Germany',
  'Halesowen, United Kingdom',
  'Hamamatsucho, Japan',
  'Hamburg, Germany',
  'Hamel, United States of America',
  'Hamilton, United Kingdom',
  'Hanover, Germany',
  'Harrisburg, United States of America',
  'Hartford, United States of America',
  'Hartsdale, United States of America',
  'Haslet, United States of America',
  'Hasselager, Denmark',
  'Hatfield, United Kingdom',
  'Hattersheim Am Main, Germany',
  'Heerewaarden, Netherlands',
  'Helsinki, Finland',
  'Henrico, United States of America',
  'Herning, Denmark',
  'Herstal, Belgium',
  'Hertford, United Kingdom',
  'Hewelsfield Common, United Kingdom',
  'Higashi-Matsuyama, Japan',
  'Hilde, Germany',
  'Hilton, South Africa',
  'Hilversum, Netherlands',
  'Ho-Ho-Kus, United States of America',
  'Hobart, Australia',
  'Hoevelaken, Netherlands',
  'Holland, United States of America',
  'Honolulu, United States of America',
  'Houston, United States of America',
  'Houthalen-Helchteren, Belgium',
  'Hrusovany U Brna, Czech Republic',
  'Huddinge, Sweden',
  'Huntington Woods, United States of America',
  'Hwaseong-Si, South Korea',
  'Hørsholm, Denmark',
  'Ibadan, Nigeria',
  'Ibi, Spain',
  'Indian Hills, United States of America',
  'Indianapolis, United States of America',
  'Irvine, United States of America',
  'Istanbul, Turkey',
  'Itajaí, Brazil',
  'Itatiba, Brazil',
  'Jacksonville, United States of America',
  'Jaipur, India',
  'Jakarta, Indonesia',
  'Jarfalla, Sweden',
  'Jarvenpaa, Finland',
  'Jasper, United States of America',
  'Jeddah, Saudi Arabia',
  'Jersey City, United States of America',
  'Jerusalem, Israel',
  'Johannesburg, South Africa',
  'Johnstown, United States of America',
  'Jubail, Saudi Arabia',
  'Jülich, Germany',
  'Karben, Germany',
  'Karlskrona, Sweden',
  'Karlsruhe, Germany',
  'Katy, United States of America',
  'Kaufering, Germany',
  'Kawasaki, Japan',
  'Kecioren, Turkey',
  'Keller, United States of America',
  'Kempele, Finland',
  'Kenosha, United States of America',
  'Kfar Saba, Israel',
  'Kirkby Wharfe, United Kingdom',
  'Kirkland, United States of America',
  'Kirkliston, United Kingdom',
  'Kista, Sweden',
  'Kitchener, Canada',
  'Kleinostheim, Germany',
  'Klosterneuburg, Austria',
  'Koeln, Germany',
  'Kolding, Denmark',
  'Kontich, Belgium',
  'Koto-Ku, Japan',
  'Krakow, Poland',
  'Kufstein, Austria',
  'Kupferzell, Germany',
  'Kuwait, Kuwait',
  'Kyiv, Ukraine',
  'Kärna, Sweden',
  'Köln Am Rhein, Germany',
  'Köln, Germany',
  'La Grange, United States of America',
  'La Mirada, United States of America',
  'La Molina, Peru',
  'La Salle, United States of America',
  'Lalitpur, Nepal',
  'Lancaster, United States of America',
  'Langley, Canada',
  'Lantana, United States of America',
  'Larkspur, United States of America',
  'Larvik, Norway',
  'Las Vegas, United States of America',
  'Lautertal, Germany',
  'Le Perreux Sur Marne, France',
  'Leeds, United Kingdom',
  'Lehrte, Germany',
  'Leicester, United Kingdom',
  'Leinfelden-Echterdingen, Germany',
  'Leipzig, Germany',
  'Lentate Sul Seveso, Italy',
  'Letterkenny, Ireland',
  'Lewis Center, United States of America',
  'Lewisville, United States of America',
  'Lichtenfels, Germany',
  'Lille, France',
  'Lima, Peru',
  'Limhamn, Sweden',
  'Linz, Austria',
  'Lisboa, Portugal',
  'Lisbon, Portugal',
  'Lisle, United States of America',
  'Lithia, United States of America',
  'Liverpool, United Kingdom',
  'Ljubljana, Slovenia',
  'Lodz, Poland',
  'Loehne, Germany',
  'Lommel, Belgium',
  'London, United Kingdom',
  'Longwood, United States of America',
  'Los Angeles, United States of America',
  'Los Molinos, Spain',
  'Louisburg, United States of America',
  'Lucknow, India',
  'Lupfig, Switzerland',
  'Luton/Dunstable, United Kingdom',
  'Lutz, United States of America',
  'Luxembourg, Luxembourg',
  'Lynbrook, United States of America',
  'Lyon, France',
  'Ma, United States of America',
  'Maarssen, Netherlands',
  'Macomb, United States of America',
  'Madison, United States of America',
  'Madrid, Spain',
  'Maisons Laffitte, France',
  'Malvern, United Kingdom',
  'Manchester, United Kingdom',
  'Mangalore, India',
  'Mannheim, Germany',
  'Manteca, United States of America',
  'Marble Falls, United States of America',
  'Markham, Canada',
  'Marshfield, United States of America',
  'Marum, Netherlands',
  'Marysville, United States of America',
  'Mashtool Al Souq, Egypt',
  'Matsudo-Shi, Japan',
  'Mechanicsburg, United States of America',
  'Mechelen, Belgium',
  'Mechernich, Germany',
  'Medellin, Colombia',
  'Medina, United States of America',
  'Meguro, Japan',
  'Meguro-Ku, Japan',
  'Melbourne Beach, United States of America',
  'Melbourne, Australia',
  'Memphis, United States of America',
  'Mexico City, Mexico',
  'Miami, United States of America',
  'Midlothian, United States of America',
  'Miesbach, Germany',
  'Milan, Italy',
  'Milano, Italy',
  'Milpitas, United States of America',
  'Milton Keynes, United Kingdom',
  'Milton, United States of America',
  'Milwaukee, United States of America',
  'Minato-Ku Roppongi 4-1-4, Japan',
  'Minato-Ku, Japan',
  'Minato-Ku, Nishi-Shinbashi 1-1-1, Hibiya Fort Tower 26F, Japan',
  'Minden, United States of America',
  'Minito-Ku, Japan',
  'Mios, France',
  'Mississauga, Canada',
  'Monaco, Monaco',
  'Monroe, United States of America',
  'Monsey, United States of America',
  'Monte Mor, Brazil',
  'Montevideo, Uruguay',
  'Montmagny, France',
  'Montpellier, France',
  'Montreal, Canada',
  'Montrose, United States of America',
  'Morehead City, United States of America',
  'Morgan Hill, United States of America',
  'Morley, Australia',
  'Morristown, United States of America',
  'Morrisville, United States of America',
  'Mosman, Australia',
  'Mount Pleasant, United States of America',
  'Muehlheim, Germany',
  'Muenster, Germany',
  'Mumbai, India',
  'Munich, Germany',
  'Munka-Ljungby, Sweden',
  'Málaga, Spain',
  'München, Germany',
  'Münster, Germany',
  'Nackenheim, Germany',
  'Nadi, Fiji',
  'Nagoya, Japan',
  'Nagoya-City, Japan',
  'Nakano, Japan',
  'Nakano-Ku, Japan',
  'Nantes, France',
  'Nanuet, United States of America',
  'Naples, United States of America',
  'Napoli, Italy',
  'Nashville, United States of America',
  'Navi Mumbai, India',
  'Nawala, Sri Lanka',
  'Neckarsulm, Germany',
  'New Braunfels, United States of America',
  'New Britain, United States of America',
  'New Castle, United States of America',
  'New Delhi, India',
  'New Egypt, United States of America',
  'New Glasgow, Canada',
  'New Lenox, United States of America',
  'New Orleans, United States of America',
  'New York City, United States of America',
  'New York, United States of America',
  'Newbridge, Ireland',
  'Newport Beach, United States of America',
  'Newton Falls, United States of America',
  'Nicosia, Cyprus',
  'Nieuwrode, Belgium',
  'Niigata-Shi, Japan',
  'Nis, Serbia',
  'Noblesville, United States of America',
  'Noida, India',
  'Nordstemmen, Germany',
  'North Attleboro, United States of America',
  'North Brunswick, United States of America',
  'North Grafton, United States of America',
  'North Hills, United States of America',
  'Notter, Netherlands',
  'Novo Mesto, Slovenia',
  'Nuernberg, Germany',
  'Nufringne, Germany',
  'Nupaky, Czech Republic',
  'Nuremberg, Germany',
  'Ny, United States of America',
  'Nürnberg, Germany',
  'Oak Island, United States of America',
  'Oegstgeest, Netherlands',
  'Oglesby, United States of America',
  'Olathe, United States of America',
  'Old Bethpage, United States of America',
  'Olen, Belgium',
  'Omaha, United States of America',
  'Onalaska, United States of America',
  'Oradell, United States of America',
  'Orlando, United States of America',
  'Orsta, Norway',
  'Orting, United States of America',
  'Osaka, Japan',
  'Oslo, Norway',
  'Otopeni, Romania',
  'Ottawa, Canada',
  'Overijse, Belgium',
  'Overland Park, United States of America',
  'Owen Sound, Canada',
  'Oxford, United States of America',
  'Pachuca De Soto, Mexico',
  'Paderborn, Germany',
  'Padua, Italy',
  'Palisades Park, United States of America',
  'Palo Alto, United States of America',
  'Panama, Panama',
  'Panchkula, India',
  'Paris, France',
  'Parker, United States of America',
  'Patna, India',
  'Pea Ridge, United States of America',
  'Pegnitz, Germany',
  'Pembroke Pines, United States of America',
  'Pennington, United States of America',
  'Peoria, United States of America',
  'Perth, Australia',
  'Petaluma, United States of America',
  'Peterborough, United Kingdom',
  'Peyton, United States of America',
  'Philadelphia, United States of America',
  'Phoenix, United States of America',
  'Pickerington, United States of America',
  'Pine, United States of America',
  'Pinneberg, Germany',
  'Pirmasens, Germany',
  'Pittsboro, United States of America',
  'Pittstown, United States of America',
  'Plano, United States of America',
  'Plantation, United States of America',
  'Plauen, Germany',
  'Pliening, Germany',
  'Plumstead, South Africa',
  'Plymouth, United States of America',
  'Port Alfred, South Africa',
  'Port Matilda, United States of America',
  'Portland, United States of America',
  'Porto Alegre, Brazil',
  'Prague, Czech Republic',
  'Praha, Czech Republic',
  'Pretoria, South Africa',
  'Princeton, United States of America',
  'Prior Lake, United States of America',
  'Pune, India',
  'Punta Gorda, United States of America',
  'Puteaux, France',
  'Pélussin, France',
  'Quatre Bornes, Mauricio',
  'Quincy, United States of America',
  'Racine, United States of America',
  'Radebeul, Germany',
  'Raleigh, United States of America',
  'Ramah, United States of America',
  'Randers Sv, Denmark',
  'Ravensburg, Germany',
  'Reading, United Kingdom',
  'Redmond, United States of America',
  'Regensburg, Germany',
  'Rehovot, Israel',
  'Rellingen, Germany',
  'Reno, United States of America',
  'Resteigne, Belgium',
  'Restinclières, France',
  'Richmond, United Kingdom',
  'Ridgefield, United States of America',
  'Rijeka, Croatia',
  'Ringwood, United Kingdom',
  'Rio Grande, Brazil',
  'Riyadh, Saudi Arabia',
  'Rochester, United States of America',
  'Rodgau, Germany',
  'Rome, Italy',
  'Roosevelt, United States of America',
  'Roseville, United States of America',
  'Roskilde, Denmark',
  'Rotkreuz, Switzerland',
  'Rybnik, Poland',
  'Rzeszów, Poland',
  'Safa, United Arab Emirates',
  'Sagamihara, Japan',
  'Saint Cloud, France',
  'Saint Johns, United States of America',
  'Saint Maur Des Fossés, France',
  'Saint Ours, France',
  'Saint Peters, United States of America',
  'Saint-Hubert, Belgium',
  'Salem, United States of America',
  'Salinas, Spain',
  'Salzburg, Austria',
  'Samobor, Croatia',
  'San Antonio, United States of America',
  'San Benedetto Del Tronto, Italy',
  'San Diego, United States of America',
  'San Francisco, Argentina',
  'San José, Costa Rica',
  'San Jsoe, Costa Rica',
  'San Juan, United States of America',
  'San Nicolás De Los Garza, Mexico',
  'San Ramon, United States of America',
  'San Sebastióan De Los Reyes, Spain',
  'Sandown, United Kingdom',
  'Sanible, United States of America',
  'Sant Boi De Llobregat, Spain',
  'Santa Fe, United States of America',
  'Santa Luzia, Brazil',
  'Santana De Parnaíba, Brazil',
  'Santiago, Chile',
  'Sao Paulo, Brazil',
  'Sapucaia Do Sul, Brazil',
  'Sarajevo, Bosnia and Herzegovina',
  'Saskatoon, Canada',
  'Savnnah, United States of America',
  'Sayama, Japan',
  'Schaerbeek, Belgium',
  'Schilde, Belgium',
  'Schmitten, Germany',
  'Scranton, United States of America',
  'Seattle, United States of America',
  'Seligenstadt, Germany',
  'Seminole, United States of America',
  'Seoul, South Korea',
  'Seyssinet-Pariset, France',
  'Shanghai, China',
  'Sherbrooke, Canada',
  'Sheridan, United States of America',
  'Sherrills Ford, United States of America',
  'Shibuya, Japan',
  'Shibuya-Ku, Japan',
  'Shiloh, United States of America',
  'Shinagawa, Japan',
  'Shinjuku, Japan',
  'Shishinagawa, Japan',
  'Shizuoka,Surugaku, Japan',
  'Siegen, Germany',
  'Silkeborg, Denmark',
  'Singapore, Singapore',
  'Sinking Spring, United States of America',
  'Sint-Andries, Belgium',
  'Sioux Falls, United States of America',
  'Sisak, Croatia',
  'Sleaford, United Kingdom',
  'Sodertalje, Sweden',
  'Soest, Netherlands',
  'Sofia, Bulgaria',
  'Solingen, Germany',
  'Solna, Sweden',
  'Somerville, United States of America',
  'South Lebanon, United States of America',
  'South Shields, United Kingdom',
  'South St. Paul, United States of America',
  'Southampton, United Kingdom',
  'Sprang-Capelle, Netherlands',
  'Spring Hill, United States of America',
  'Springfield, United States of America',
  'Sri Ganganagar, India',
  'St Charles, United States of America',
  "St Germain Au Mont D'Or, France",
  'St Paul, United States of America',
  'St Petersburg, United States of America',
  'St-Jean-Baptiste, Canada',
  'St. Albans, United Kingdom',
  'St. Louis, United States of America',
  'Stanley, United Kingdom',
  'Starkville, United States of America',
  'Stavanger, Norway',
  'Stein Am Rhein, Switzerland',
  'Stevenage, United Kingdom',
  'Stockholm, Sweden',
  'Stoke-On-Trent, United Kingdom',
  'Strijen, Netherlands',
  'Stromness, United Kingdom',
  'Stuttgart, Germany',
  'Sugar Land, United States of America',
  'Sumare, Brazil',
  'Sumaré, Brazil',
  'Sunderland, United Kingdom',
  'Sutton Coldfield, United Kingdom',
  'Suwanee, United States of America',
  'Swansea, United Kingdom',
  'Sydney, Australia',
  'São Paulo, Brazil',
  'Tachikawa, Japan',
  'Taipei, Taiwan',
  'Taito-Ku, Japan',
  'Tama, Japan',
  'Tampa, United States of America',
  'Tarm, Denmark',
  'Tauranga, New Zealand',
  'Tecumseh, United States of America',
  'Ternitz, Austria',
  'Thalwil, Switzerland',
  'Thatcham, United Kingdom',
  'The Villages, United States of America',
  'The Woodlands, United States of America',
  'Thrissur, India',
  'Titusville, United States of America',
  'Tokyo, Japan',
  'Toronto, Canada',
  'Torrejón De Ardoz, Spain',
  'Torres, Brazil',
  'Toshima, Japan',
  'Toulouse, France',
  'Tremesne, Czech Republic',
  'Trim, Ireland',
  'Trondheim, Norway',
  'Tunis, Tunisia',
  'Turnhout, Belgium',
  'Ulm, Germany',
  'Umeå, Sweden',
  'Uncasville, United States of America',
  'University Heights, United States of America',
  'Unterfoehring (Near Munich), Germany',
  'Utrecht, Netherlands',
  'Uxbridge, Canada',
  'Uxbridge, United Kingdom',
  'Vadodara, India',
  'Vail, United States of America',
  'Valley Stream, United States of America',
  'Valrico, United States of America',
  'Vancouver, Canada',
  'Vaughan, Canada',
  'Versailles, France',
  'Vettre, Norway',
  'Vienna, Austria',
  'Vienne, France',
  'Villecresnes, France',
  'Vilnius, Lithuania',
  'Vincennes, France',
  'Vinhedo, Brazil',
  'Vélizy-Villacoublay, France',
  'Waasmunster, Belgium',
  'Wachtendonk, Germany',
  'Walnut Creek, United States of America',
  'Waltham, United States of America',
  'Wangerland-Hooksiel, Germany',
  'Warner, United States of America',
  'Warsaw, Poland',
  'Warszawa, Poland',
  'Washington, United States of America',
  'Waterloo, Canada',
  'Waynesburg, United States of America',
  'Weehawkend, United States of America',
  'Weiden, Germany',
  'Weikersheim, Germany',
  'Weinsheim, Germany',
  'Weisenheim Am Sand, Germany',
  'Wellington, New Zealand',
  'Wenatchee, United States of America',
  'West Chester, United States of America',
  'West Des Moines, United States of America',
  'West Milford, United States of America',
  'West Orange, United States of America',
  'Westbury, United Kingdom',
  'Wezemaal, Belgium',
  'Whitby, Canada',
  'Whitehouse Station, United States of America',
  'Wien, Austria',
  'Wiesbaden, Germany',
  'Wilkesboro, United States of America',
  'Wilmslow, United Kingdom',
  'Wimborne, United Kingdom',
  'Windischgarsten, Austria',
  'Winnipeg, Canada',
  'Winter Garden, United States of America',
  'Wirral, United Kingdom',
  'Wisbech, United Kingdom',
  'Wixams, United Kingdom',
  'Wolverhampton, United Kingdom',
  'Wombourne, United Kingdom',
  'Woodbridge, United States of America',
  'Worcester, United Kingdom',
  'Worms, Germany',
  'Wroclaw, Poland',
  'Wrocław, Poland',
  'Würenlos, Switzerland',
  "Xi'An, China",
  'Yaounde, Cameroon',
  'Yashio-Shi, Japan',
  'Yerevan, Armenia',
  'Yokohama City, Japan',
  'Yokohama, Japan',
  'Yongin-Si, South Korea',
  'York, United Kingdom',
  'Zaandam, Netherlands',
  'Zagreb, Croatia',
  'Zaragoza, Spain',
  'Zh, Switzerland',
  'Zifta, Egypt',
  'Zionsville, United States of America',
  'Zurich, Switzerland',
  'Zürich, Switzerland',
  'Ørsta, Norway',
];

export const CHAMPION_SKILLS: string[] = [
  'AI on Power',
  'AIX (Developer)',
  'AIX/Oracle',
  'API Connect',
  'API Connect Essentials',
  'API-Led Integration',
  'APM/Predictive Maintenance',
  'Akamai API Security',
  'Amazon Web Services (AWS)',
  'Analytics Content Hub',
  'Analytics for batch resiliency',
  'Android',
  'Anomaly Analytics with Watson for Z',
  'Apache Kafka',
  'Apache Spark',
  'App Connect',
  'App Connect Enterprise (ACE)',
  'Application Delivery Foundation for z/OS (ADFZ)',
  'Application Modernization Accelerator (AMA)',
  'Application Performance Management Connect for Z',
  'Application Security Services',
  'Apptio One',
  'Aspera',
  'Asset Lifecycle Management',
  'Asset Maintenance (EAM)',
  'Asset Management (General)',
  'Automating your Business',
  'BRMS',
  'Batch Resiliency for Z',
  'Blockchain (Developer)',
  'Blueworks Live',
  'Business Automation Manager Open Edition',
  'Business Automation Workflow',
  'Business Process Management (IBM BPM, BAW, Case Manager)',
  'CICS VSAM Recovery',
  'CMC',
  'COBOL (Developer',
  'CPACF',
  'Chat Ops for Z',
  'ClearCase',
  'Cloud Native Apps with AI on IBM Cloud',
  'Cloud Pak for AIOps',
  'Cloud Pak for Applications (CP4Apps)',
  'Cloud Pak for Business Automation',
  'Cloud Pak for Data',
  'Cloud Pak for Integration',
  'Cloud Pak for Network Automation',
  'Cloud Pak for Security',
  'Cloud Security Services',
  'Cloudability',
  'Code for IBM i',
  'Cognos Analytics',
  'Confidential Containers',
  'Container registry',
  'Content Management and Capture',
  'Controller',
  'Crypto Express / TKE',
  'DB2 AI for z/OS',
  'DRA on PowerVS',
  'DS8K SafeGuarded Copy',
  'Data Fabric',
  'Data Governance',
  'Data Management',
  'Data Privacy for Diagnostics',
  'Data Product Hub',
  'Data Replication',
  'Data Security Services',
  'Data Virtualization',
  'DataOps',
  'DataPower',
  'DataStage',
  'DataStax Astra DB',
  'Datacap Open Editions',
  'Db2',
  'Db2 (Developer)',
  'Db2 Analytics Accelerator for z/OS',
  'Db2 Warehouse (Developer)',
  'Db2 for IBM i',
  'Db2 for z/OS',
  'Db2 for z/OS Data Gate',
  'Db2 tools for z/OS',
  'Decision Management',
  'Decision Optimization',
  'Deployable Architectures on IBM Cloud',
  'Developer for z/OS (IDZ)',
  'Development on IBM LinuxONE (Developer)',
  'Docker',
  'ECM System Monitor',
  'Eclipse OpenJ9',
  'Encryption Facility',
  'Engineering Lifecycle Management (General)',
  'Enterprise Application Runtimes (EAR)',
  'Enterprise Application Service for Java (EASeJ)',
  'Envizi',
  'Envizi ESG Suite',
  'Event Streams',
  'Event-Led Integration',
  'FileNet',
  'Governance, Risk, and Compliance (GRC)',
  'Guardium',
  'Guardium Data Encryption',
  'Guardium Data Protection',
  'Guardium Data Security Center',
  'Guardium Discover and Classify',
  'Guardium Insights',
  'Guardium S TAPs for z/OS',
  'Guardium Vulnerability Assessment',
  'HMC',
  'HashiCorp Boundary',
  'HashiCorp Cloud Platform',
  'HashiCorp Consul',
  'HashiCorp Nomad',
  'HashiCorp Packer',
  'HashiCorp Terraform',
  'HashiCorp Vagrant',
  'HashiCorp Vault',
  'HashiCorp Waypoint',
  'High Level Assembler and Toolkit Feature',
  'High Performance Computing - Spectrum LSF',
  'IAM Services',
  'IBM 3592 tape cartridges',
  'IBM AIX',
  'IBM API Connect (Developer)',
  'IBM App Connect (Developer)',
  'IBM Apptio',
  'IBM Apptio Platform',
  'IBM Bob',
  'IBM Cloud (Developer)',
  'IBM Cloud Bare Metal Servers',
  'IBM Cloud CLI',
  'IBM Cloud Code Engine',
  'IBM Cloud Code Engine (Developer)',
  'IBM Cloud Continuous Delivery',
  'IBM Cloud Databases for EnterpriseDB',
  'IBM Cloud Databases for MySQL',
  'IBM Cloud Databases for PostgreSQL',
  'IBM Cloud Internet Services',
  'IBM Cloud Kubernetes Service',
  'IBM Cloud Monitoring',
  'IBM Cloud Object Storage',
  'IBM Cloud Object Storage (IaaS)',
  'IBM Cloud Object Storage (on Premises)',
  'IBM Cloud Pak for AIOps (Developer)',
  'IBM Cloud Pak for Applications (Developer)',
  'IBM Cloud Pak for Business Automation (Developer)',
  'IBM Cloud Pak for Data (Developer)',
  'IBM Cloud Pak for Integration (Developer)',
  'IBM Cloud Security and Compliance Center',
  'IBM Cloud Virtual Server for VPC',
  'IBM Cloud for Financial Services',
  'IBM Cloud for SAP on PowerVS with Certified Instances',
  'IBM Cloudability',
  'IBM Concert',
  'IBM Concert for Z',
  'IBM Content Manager',
  'IBM DS8880F',
  'IBM DS8900F',
  'IBM DS8A00',
  'IBM Db2 Mirror for i',
  'IBM Db2 Warehouse on Power',
  'IBM Db2 for i',
  'IBM Defender Data Protect',
  'IBM DevOps Loop',
  'IBM DevOps Platform',
  'IBM Diamondback Tape Library',
  'IBM Encryption Platform',
  'IBM Engineering Requirements Management DOORS',
  'IBM Engineering Requirements Management DOORS Next',
  'IBM Engineering Test Management (ETM)',
  'IBM Engineering Workflow (EWM)',
  'IBM Enterprise COBOL for z/OS',
  'IBM Event Automation',
  'IBM Event Streams',
  'IBM Fusion',
  'IBM GDPS® for business continuity',
  'IBM Granite models (Developer)',
  'IBM Guardium Discover and Classify',
  'IBM Guardium Key Lifecycle Manager',
  'IBM Identity Governance & Intelligence',
  'IBM JSphere for Java',
  'IBM Knowledge Catalog',
  'IBM Kubecost',
  'IBM Kubernetes Services',
  'IBM Langflow',
  'IBM LinuxONE (Hardware)',
  'IBM LinuxONE Emperor 5',
  'IBM MQ (Developer)',
  'IBM Managed Security Services',
  'IBM Manta Data Lineage',
  'IBM Maximo Application Suite (General)',
  'IBM Maximo Application Suite - Assist',
  'IBM Maximo Application Suite - Field Service Management',
  'IBM Maximo Application Suite - Health',
  'IBM Maximo Application Suite - IT',
  'IBM Maximo Application Suite - Industry Solutions',
  'IBM Maximo Application Suite - Integration (ERP, CRM, or other third-party applications)',
  'IBM Maximo Application Suite - Manage',
  'IBM Maximo Application Suite - Mobile',
  'IBM Maximo Application Suite - Monitor',
  'IBM Maximo Application Suite - Predict',
  'IBM Maximo Application Suite - Reliability Strategies',
  'IBM Maximo Application Suite - Visual Inspection',
  'IBM Maximo Application Suite - Work Order Intelligence (GenAI)',
  'IBM Maximo Visual Inspection (Developer)',
  'IBM Power',
  'IBM Power (Developer)',
  'IBM Power E1150',
  'IBM Power E1180',
  'IBM Power S1122',
  'IBM Power S1124',
  'IBM Power Virtual Server',
  'IBM Power with IBM Storage Solutions',
  'IBM PowerHA System Mirror',
  'IBM PowerSC',
  'IBM PowerVC',
  'IBM PowerVM',
  'IBM Rational Developer for i',
  'IBM Rhapsody Systems Engineering',
  'IBM Runtimes for Business (IRB)',
  'IBM SAN Volume Controller',
  'IBM Secret Server',
  'IBM Semeru Runtimes',
  'IBM Spectrum Control',
  'IBM Sterling',
  'IBM Sterling B2B Integration (SaaS)',
  'IBM Sterling B2B Integrator',
  'IBM Sterling Managed File Transfer',
  'IBM Sterling Order Management',
  'IBM Sterling Secure File Transfer',
  'IBM Sterling Transformation Extender',
  'IBM Storage Archive',
  'IBM Storage Ceph',
  'IBM Storage Copy Data Management',
  'IBM Storage DS8000',
  'IBM Storage Deep Archive',
  'IBM Storage Defender',
  'IBM Storage FlashSystem',
  'IBM Storage FlashSystem 5200',
  'IBM Storage FlashSystem 5300',
  'IBM Storage FlashSystem 7300',
  'IBM Storage FlashSystem 9500',
  'IBM Storage Insights',
  'IBM Storage Networking SAN',
  'IBM Storage Networking SAN24B-6',
  'IBM Storage Networking SAN32C-6 Fabric Switch',
  'IBM Storage Networking SAN64B-6',
  'IBM Storage Protect',
  'IBM Storage Protect for Cloud',
  'IBM Storage Scale',
  'IBM Storage Scale System',
  'IBM Storage Sentinel',
  'IBM Storage Software',
  'IBM Storage Tape',
  'IBM Storage Virtualize',
  'IBM Storage for AI',
  'IBM TS4300 Tape Library',
  'IBM TS4500 Tape Drive',
  'IBM TS7770 Virtual Tape Library',
  'IBM TS7780 Virtual Tape Library',
  'IBM Tape Drives',
  'IBM Tape Library',
  'IBM Targetprocess',
  'IBM Technical Expert Labs',
  'IBM Transformation Advisor (TA)',
  'IBM Trusteer',
  'IBM Trusteer Mobile',
  'IBM VM Recovery Manager',
  'IBM Vault for Z (HashiCorp)',
  'IBM Verify Access',
  'IBM Verify Privilege Manager',
  'IBM Verify Privilege Vault',
  'IBM WebSphere Application Server',
  'IBM Workload Automation',
  'IBM Z & IBM LinuxONE Hybrid Cloud Platform',
  'IBM Z (Hardware)',
  'IBM Z Cyber Vault',
  'IBM Z Decision Support',
  'IBM Z Digital Integration Hub',
  'IBM Z Enterprise AI',
  'IBM Z IntelliMagic Vision for z/OS',
  'IBM Z Multi-Factor Authentication (IBM Z MFA)',
  'IBM Z Open Editor (Developer)',
  'IBM Z Seucirty Portal',
  'IBM Z Skills',
  'IBM Z Test Accelerator',
  'IBM Z and LinuxONE Security and Compliance Center (zSCC)',
  'IBM Z and LinuxONE Sustainability',
  'IBM Z cryptographic hardware',
  'IBM developer for z/OS (Developer)',
  'IBM i',
  'IBM i (Developer)',
  'IBM i Development Pack',
  'IBM i Modernization Engine for Lifecycle Integration',
  'IBM z/OS Debugger (Developer)',
  'IBM zSecure',
  'IBM zSecure Admin',
  'IBM zSecure Alert',
  'IBM zSecure Audit',
  'IBM zSecure CICS Toolkit',
  'IBM zSecure Command Verifier',
  'IBM zSecure Multi-factor Authentication',
  'IBM® Application Discovery and Delivery Intelligence (ADDI)',
  'ICSF',
  'IDZ (Developer)',
  'IMS',
  'InfoSphere Optim',
  'Informix (On Prem or Cloud)',
  'Infrastructure and Endpoint Services',
  'Instana',
  'Instana (Developer)',
  'InstructLab',
  'IntelliMagic with Apptio',
  'Istio',
  'Jakarta EE',
  'Java Platform',
  'Jupyter',
  'KServe',
  'KVM on Z',
  'Knative',
  'Kubeflow',
  'Linux on IBM Power',
  'Linux on IBM Power (Developer)',
  'Linux on Z',
  'MQ',
  'MQ for z/OS',
  'MQTT',
  'MaaS360 with Watson',
  'Machine Learning for z/OS',
  'Managed Detection and Response',
  'Master Data Management',
  'Maximo Application Suite (Developer)',
  'MicroProfile',
  'Modernized Runtime Extension for Java (MoRE)',
  'Monitoring for Z',
  'NetView for Z',
  'Netcool Insights',
  'Netcool Omnibus',
  'Netcool family (NOI, NPI)',
  'Netezza Performance Server',
  'Netezza Performance Server (Developer)',
  'Network Security',
  'Node-RED',
  'OMEGAMON (all) for Z',
  'OMEGAMON Grafana UI',
  'Observability by Instana APM on z/OS',
  'Open Enterprise Python for z/OS',
  'Open Liberty',
  'Open Source Library Support',
  'Open Source Offerings',
  'Operational Decision Manager',
  'Optimize Enterprise VMware Workloads',
  'Oracle on IBM Power',
  'Other',
  'Partner Engagement Manager',
  'Performance and Capacity Analytics for Z',
  'Pervasive Encryption',
  'Planning Analytics',
  'Power Private Cloud',
  'Power Virtual Server (Iaas)',
  'PowerVS (Cloud)',
  'PowerVS AIX',
  'PowerVS Db2',
  'PowerVS IBMi',
  'PowerVS Linux',
  'PowerVS Networking',
  'Process Mining',
  'PyTorch',
  'QRadar',
  'QRadar Log Insights',
  'QRadar NDR',
  'QRadar Network Insights',
  'QRadar SIEM',
  'QRadar SOAR',
  'Qiskit',
  'Qiskit Runtime',
  'Quantum Computing',
  'Quantum Safe System',
  'RACF',
  'RISE With SAP on IBM Power Virtual Server',
  'RPG',
  'Rational',
  'Red Hat Ansible Automation Platform (Developer)',
  'Red Hat Ansible IBM Z and LinuxONE (Developer)',
  'Red Hat Enterprise Linux (Developer)',
  'Red Hat Open Shift IBM Z and LinuxONE',
  'Red Hat OpenShift (Developer)',
  'Red Hat OpenShift AI (Developer)',
  'Red Hat OpenShift on IBM Cloud (Developer)',
  'Red Hat OpenShift on IBM Power',
  'Red Hat OpenShift on IBM Power (Developer)',
  'Robotic Process Automation (RPA)',
  'SAP HANA on IBM Power',
  'SPSS Modeler (Developer)',
  'SPSS Modeller',
  'SPSS Statistics',
  'Security Expert Labs',
  'Security Intelligence Operations and Consulting Services',
  'Security Strategy',
  'SevOne',
  'Spectrum',
  'Spring',
  'Sterling Data Exchange (General)',
  'StreamSets',
  'Supply Chain Intelligence Suite - Control Tower',
  'System Automation for Z',
  'Systems Management for Z',
  'TRIRIGA Application Suite (General)',
  'TRIRIGA Application Suite - Capital Planning Projects',
  'TRIRIGA Application Suite - Facilities Lease Management',
  'TRIRIGA Application Suite - Maintenance and Operations',
  'TRIRIGA Application Suite - Space Planning and Management',
  'Tailored Fit Pricing',
  'Tekton',
  'Telum II for IBM Z',
  'Terraform',
  'Threat Detection for z/OS',
  'Threat Management Services',
  'Tivoli',
  'Tivoli for IBM Z',
  'Turbonomic',
  'UKO / EKMF Workstation',
  'UrbanCode',
  'VM Recovery Manager',
  'VMRM Solution Planning',
  'VMware Cloud Foundation (VCF) for VPC',
  'Verify (Developer)',
  'Verify SaaS',
  'Watson API',
  'Watson APIs',
  'Watson Assistant',
  'Watson Language Translator',
  'Watson Machine Learning',
  'Watson Natural Language Classifier',
  'Watson Natural Language Understanding',
  'Watson OpenScale',
  'Watson Query',
  'Watson Speech to Text',
  'Watson Studio',
  'Watson Text to Speech',
  'Wazi',
  'Wazi-as-a-service',
  'WebSphere Automation',
  'WebSphere Hybrid Edition',
  'WebSphere Liberty',
  'WebSphere Open Liberty',
  'Websphere Liberty Core',
  'Workload Scheduler for IBM Z',
  'X-Force Threat Intelligence',
  'X-Force Threat Management',
  'Z Open Automation Utilities (ZOAU)',
  'Z Security and Compliance Center (ZSCC)',
  'Zero Trust',
  'Zowe',
  'vHMC',
  'watsonx',
  'watsonx (Developer)',
  'watsonx Assistant',
  'watsonx Assistant for Z',
  'watsonx BI Assistant',
  'watsonx Code Assistant',
  'watsonx Code Assistant for Enterprise JAVA',
  'watsonx Code Assistant for Red Hat Ansible',
  'watsonx Code Assistant for Z',
  'watsonx Code Assistant for Z (Developer)',
  'watsonx Data Lakehouse',
  'watsonx Discovery',
  'watsonx Orchestrate',
  'watsonx Orchestrate (Developer)',
  'watsonx. Governance (Developer)',
  'watsonx.ai',
  'watsonx.ai (Developer)',
  'watsonx.data',
  'watsonx.data (Developer)',
  'watsonx.governance',
  'webMethods',
  'z/OS',
  'z/OS Anomoly Analytics',
  'z/OS Change Tracker',
  'z/OS Comm Server',
  'z/OS Connect',
  'z/OS Containers',
  'z/OS DFSMS',
  'z/OS Sysplex EDR',
  'z/OSMF',
  'z/TPF',
  'z/VM',
  'z/VSE',
  'z17',
  'zCX',
  'zERT',
  'zSecure',
  'zSecure Admin',
];
